import React, { Component, Fragment } from 'react';
import cx from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Nav from '../AppNav/VerticalNavWrapper';

class AppSidebar extends Component {
  state = {};

  render() {
    let {
      backgroundColor,
      enableBackgroundImage,
      enableSidebarShadow,
      backgroundImage,
      backgroundImageOpacity
    } = this.props;

    return (
      <Fragment>
        <div
          className="sidebar-mobile-overlay"
          onClick={this.toggleMobileSidebar}
        />
        <div className={cx("app-sidebar", backgroundColor, {
          "sidebar-shadow": enableSidebarShadow
        })}
        >
          <PerfectScrollbar>
            <div className="app-sidebar__inner">
              <Nav />
            </div>
          </PerfectScrollbar>
          <div
            className={cx("app-sidebar-bg", backgroundImageOpacity)}
            style={{
              backgroundImage: enableBackgroundImage
                ? "url(" + backgroundImage + ")"
                : null
            }}
          >
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AppSidebar;
